<template>
    <div class="main">
        <section id="brn-tour-single" class="diagonal">
            <BorderDecoration class="top-left" style="left: -10%" :primary="'var(--color-secondary)'" :secondary="'var(--color-gray-light)'"/>
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 intro">
                        <h6 class="text-uppercase text-wide-5 text-secondary">event / {{ event.name }}</h6>
                        <ChalkDecoration>
                            <h2>{{ event.name }}</h2>
                        </ChalkDecoration>
<!--                        <TourAttributes class="my-4"-->
<!--                                        :duration="tour.duration + ' hours'"-->
<!--                                        language="English"-->
<!--                                        equipment="Free Helmet"-->
<!--                        />-->
                        <a href="javascript:void(0);" class="btn btn-primary px-3 mb-4" @click="addToCart()">Book now</a>
                        <div class="row tour-description my-5">
                            <p v-html="event.description"></p>
                        </div>
                        <a href="javascript:void(0);" class="btn btn-primary px-3 mb-4" @click="addToCart()">Book now</a>
                    </div>
                    <div class="images">
                        <img :src="event.event_media[1] !== undefined ? event.event_media[1].fullUrl : '/assets/images/backgrounds/tour-default-1.jpg'" alt="Event">
                        <img :src="event.event_media[0] !== undefined ? event.event_media[0].fullUrl : '/assets/images/backgrounds/tour-default-0.jpg'" alt="Event">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import TourAttributes from "../components/TourAttributes";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import ApiRequest from "../../utils/api-request";
import SettingsMixin from "../../mixins/SettingsMixin";
import {mapActions} from "vuex";
import EventItem from "../../models/TourItem";
import FareHarborMixin from "../../mixins/FareHarborMixin";
export default {
    name: "RentalsEventSingle",
    mixins: [SettingsMixin, FareHarborMixin],
    components: {ChalkDecoration, TourAttributes, BorderDecoration},
    data() {
        return {
            event: {}
        }
    },
    mounted() {
        new ApiRequest().getEventBySlug(this.$attrs.slug).then(
            (response) => {
                this.event = response.data.event;
            }
        );
    },
    methods: {
        ...mapActions('cart', ['addEvent']),
        addToCart() {
            if (this.fareHarborMode()) this.openFareHarborModal();
            this.addEvent(new EventItem(this.event)).then(res => {
                if (res) {
                    this.$notify({
                        title: 'Great choice!',
                        text: '«' + this.tour.name + '» is waiting for you!',
                        duration: -1
                    });
                    setTimeout(() => {
                        window.location.href = '/checkout';
                    }, 2000);
                    return;
                }

                this.$notify({
                    title: 'Oops!',
                    text: 'Can\'t add new tour while there are tours or bikes in cart!'
                });
            });

        }
    }
}
</script>

<style scoped>

</style>
